export default function getWifiNetworks() {
  return {
    name: 'Para conectar-se a internet é necessário realizar um cadastro após a conexão do celular na rede Wi-Fi',
    password: ''
  }
}
